export default "__VITE_ASSET__himjxce6__"